import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { FIRST_PASS_PURPLE } from './qcTheme';
import {
  CloseButton,
  FirstPassButton,
  ModalHeader,
  ModalTitle,
  TextButton,
} from './workspaceModalParts';

const TitleWithIcon = styled(ModalTitle)({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10px',
});

const Body = styled('div')({
  padding: '22px 24px',
});

const CountPill = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  background: 'rgba(94,53,177,0.12)',
  color: FIRST_PASS_PURPLE,
  border: '1px solid rgba(94,53,177,0.4)',
  borderRadius: '15px',
  height: '30px',
  padding: '0 16px',
  fontSize: '0.8rem',
  fontWeight: 700,
});

const BodyText = styled('p')({
  margin: '16px 0 0',
  fontSize: '0.9rem',
  lineHeight: 1.6,
  color: 'rgba(0,0,0,0.75)',
});

const Footer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '12px',
  padding: '16px 24px 22px',
  borderTop: '1px solid rgba(0,0,0,0.1)',
});

export interface FirstPassBlockModalProps {
  open: boolean;
  openCount: number;
  onReviewFirstPass: () => void;
  onClose: () => void;
}

export default function FirstPassBlockModal({ open, openCount, onReviewFirstPass, onClose }: FirstPassBlockModalProps): JSX.Element {
  const plural = openCount === 1 ? '' : 's';
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-label='First Pass review not complete'
      PaperProps={{ sx: { width: 560, maxWidth: 'calc(100% - 32px)', borderRadius: '4px' } }}
      maxWidth={false}
    >
      <ModalHeader>
        <TitleWithIcon>
          <AutoAwesomeIcon sx={{ fontSize: 22, color: FIRST_PASS_PURPLE }} />
          First Pass Review Not Complete
        </TitleWithIcon>
        <CloseButton type='button' aria-label='Close First Pass reminder' onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </ModalHeader>
      <Body>
        <CountPill>{openCount} First Pass issue{plural} still need{openCount === 1 ? 's' : ''} your review</CountPill>
        <BodyText>
          Every First Pass issue must be accepted or edited before QC issues can be submitted to
          the assessor. Review the remaining items, then submit.
        </BodyText>
      </Body>
      <Footer>
        <TextButton type='button' onClick={onClose}>Cancel</TextButton>
        <FirstPassButton type='button' onClick={onReviewFirstPass}>
          <ArrowForwardIcon sx={{ fontSize: 17 }} />
          Review First Pass Issues
        </FirstPassButton>
      </Footer>
    </Dialog>
  );
}
